<!-- 收件人信息弹框 -->
<template>
    <el-dialog @close="close" append-to-body :visible.sync="dialogVisible" width="45%">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm">
            <el-form-item label="配发票收件人姓名:" prop="userName">
                <el-input style="width: 2.5rem;" size="small" placeholder="请填写姓名" v-model="ruleForm.userName"></el-input>
            </el-form-item>
            <el-form-item label="配发票收件手机号:" prop="userPhone">
                <el-input style="width: 2.5rem;" size="small" placeholder="请填写手机号" v-model="ruleForm.userPhone"></el-input>
            </el-form-item>
            <el-form-item label="详细地址" prop="address">
                <el-input style="width: 4rem;" size="small" type="textarea" :rows="2" placeholder="请输入详细地址"
                    v-model="ruleForm.address">
                </el-input> </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="submitForm('ruleForm')">保 存</el-button>
        </span>
    </el-dialog>
</template>

<script>
import Api from '@/components/Api/index'
export default {
    components: {},
    data() {
        return {
            ruleForm: {
                "address": "",//收货地址
                "companyName": "",//公司名称
                "compnayId": null,//公司ID
                "id": null,
                "userId": null,
                "userName": "",//收货人姓名
                "userPhone": ""//收货人手机号码	
            },
            rules: {
                userName: [
                    { required: true, message: '请填写收件人姓名', trigger: 'blur' },
                    { min: 2, max: 6, message: '长度在 2 到 6 个字符', trigger: 'blur' }
                ],
                address: [
                    { required: true, message: '请填写收件地址', trigger: 'change' }
                ],
                userPhone: [
                    { required: true, message: "请输入手机号码", trigger: "blur" },
                    {
                        validator: function (rule, value, callback) {
                            if (/^1[3456789]\d{9}$/.test(value) == false) {
                                callback(new Error("请输入正确的手机号"));
                            } else {
                                callback();
                            }
                        },
                        trigger: "blur",
                    },
                ],
            },
            dialogVisible: false,
            value: '',
        }
    },
    computed: {},
    watch: {},
    methods: {
        initClick(data) {
            console.log(data, '说的是弟弟说的');
            this.ruleForm.companyName = data
            this.dialogVisible = true
        },
        submitForm(formName) {
            let obj = JSON.parse(JSON.stringify(this.ruleForm))
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    console.log('看看保存的数据', this.ruleForm);
                    new Api("user")
                        .addShippingAddress(this.ruleForm)
                        .then((res) => {
                            if (res.status == 200) {
                                this.$message.success({message:'保存成功'})
                                obj.id = res.data
                                this.$emit('addressInfoClick',obj)
                                this.dialogVisible = false
                            } else {
                                this.$message.error({ message: res.statusText });
                                
                            }
                        });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        close() {
            this.$refs['ruleForm'].resetFields();
        }
    },
    created() {

    },
    mounted() {

    },
}
</script>
<style lang='scss' scoped>
.lineBox {
    margin-bottom: 0.2.5rem;

    .cardLineLineBox {
        display: flex;
        align-items: center;
        flex-wrap: wrap;

        .cardLine {
            display: flex;
            align-items: center;
            margin-bottom: 0.15rem;
            margin-right: 0.25rem;

            .cardLineP1 {
                color: #606266;
                white-space: nowrap;

                span {
                    color: red;
                    margin-right: 0.05rem;
                }
            }
        }

    }

    .lineBoxTitle {
        display: flex;
        align-items: center;
        margin-bottom: 0.2rem;

        .lineBoxTitleP1 {
            font-size: 0.24rem;
            margin-right: 0.5rem;
        }

        .lineBoxTitleP2 {
            color: #57a4f2;
            cursor: pointer;

            &:hover {
                text-decoration: underline;
            }
        }
    }
}
</style>